import { useEffect } from 'react';
import { usePassportSSO } from '../../hooks/use-passport-sso';

/**
 * PassportListener Component
 *
 * Listens for Passport SSO sessions and automatically logs users in.
 * SSO code exchange is handled by use-passport-sso.js hook.
 *
 * This component should be rendered at the app root level, alongside WalletListener.
 *
 * Priority: Passport session takes precedence over wallet connection.
 * If user has a valid omni_session cookie, they're logged in via Passport.
 * If not, they can still use wallet-based login.
 */
export default function PassportListener() {
  const { isCheckingSession, hasPassportSession, isExchangingCode } = usePassportSSO();

  // Log session status for debugging
  useEffect(() => {
    if (!isCheckingSession && !isExchangingCode) {
      if (hasPassportSession) {
        console.log('[PassportListener] Valid Passport session detected');
      }
    }
  }, [isCheckingSession, hasPassportSession, isExchangingCode]);

  // This is a listener component - it doesn't render anything
  return null;
}
